import { withTheme } from '@emotion/react';

/**
 * Chevron
 * @props   {string} stroke  Hex color for stroke
 */

function Chevron(props) {
  const { neutral3 } = props.theme.colors;
  const { stroke = neutral3, className } = props;
  
  return (
    <svg className={className} width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="1" d="M1 1L4 4L7 1" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
 };
 
 export default withTheme(Chevron);